var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.eo},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),(_vm.$root.profile.role === 10001)?_c('div',[_vm._v(" "+_vm._s(_vm.data)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }